<template>
  <div class="form add-class">
    <div class="form__header">
      <h3>Создать класс</h3>
    </div>

    <div class="form__body">
      <form>
        <Input 
          class="form__field" 
          v-model="formData.title" 
          label="Название" 
          type="text" 
          id="class-title" 
          :required="true" 
        />
        <p class="form__field">
          <span>День:</span>
          <select 
            v-model="formData.day"
            class="required"
            :class="{
              valid: formData.day,
              invalid: !formData.day,
            }"
          >
            <option value="" selected disabled>Выберите день занятий</option>
            <option v-for="val in days" :key="val.id" :value="val">{{ val }}</option>
          </select>
        </p>

        <p class="form__field">
          <span>Время:</span>
          <vue-timepicker 
            class="required"
            :class="{
              valid: formData.time,
              invalid: !formData.time,
            }"
            input-width="100%" 
            format="HH:mm" 
            v-model="formData.time"
          ></vue-timepicker>
        </p>

        <p class="form__field">
          <span>Описание:</span>
          <textarea v-model="formData.desc" rows="2"></textarea>
        </p>

      </form>
    </div>
    <div class="form__footer">
      <SubmitButton :isValid="isValid" @submit="sendForm" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
import { mapActions, mapGetters } from 'vuex'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  name: "add-class",
  mixins: [ form_mix ],
  components: { VueTimepicker },
  data() {
    return {
      formData: {
        title: '',
        day: '',
        time: '',
        desc: ''
      },
      days: [
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье',
      ],
      requiredKeys: ['title', 'day', 'time']
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    ...mapActions({
      postClass: 'teacher/postClass'
    }),
    async sendForm() {
      this.formData.user_id = this.user.id
      this.formData.is_outside = this.user.is_outside
      await this.postClass(this.formData)
      this.$emit('close-popup')
    }
  }
}
</script>
